import {
    ClosetColor,
    DoorColor,
    DoorStyle,
    DrawerColor,
    HandleColor,
    HandleStyle,
    ProjectScope,
    RodColor,
} from '../config';

export const FILTER_TYPE = Object.freeze({
    ALL: 'ALL',
    STARRED: 'STARRED',
    RECENT: 'RECENT',
    DRAFTS: 'DRAFTS',
});
export const SORT_TYPE = Object.freeze({
    OLDEST: 'oldest',
    NEWEST: 'newest',
});
export const VIEWER_MODE = Object.freeze({
    GRID: 'grid',
    LIST: 'list',
});

export const STEP_TYPE = Object.freeze({
    CREATE: 'create',
    MAPPING: 'mapping',
    MATRIX: 'matrix',
    DESIGNER: 'designer',
});

export const filterButton = [
    {
        name: 'All',
        value: FILTER_TYPE.ALL,
        count: 28,
    },
    {
        name: 'Starred',
        value: FILTER_TYPE.STARRED,
        count: 6,
    },
    {
        name: 'Recents',
        value: FILTER_TYPE.RECENT,
        count: 10,
    },
    {
        name: 'Drafts',
        value: FILTER_TYPE.DRAFTS,
        count: 0,
    },
];
export const sortingButton = [
    {
        name: 'Created Date',
        value: SORT_TYPE.OLDEST,
    },
    {
        name: 'Last Modified',
        value: SORT_TYPE.NEWEST,
    },
];
export const ScopOptions = [
    {
        name: 'All Closets',
        value: ProjectScope.ALL_CLOSETS,
    },
    {
        name: 'Bedroom',
        value: ProjectScope.BEDROOM,
    },
    {
        name: 'Closet',
        value: ProjectScope.CLOSET,
    },
    {
        name: 'Custom',
        value: ProjectScope.CUSTOM,
    },
];
export const closetColor = [
    {
        name: 'White',
        value: ClosetColor.WHITE,
        colorCode: '#ffffff',
    },
    {
        name: 'Grey',
        value: ClosetColor.GREY,
        colorCode: '#808080',
    },
    {
        name: 'Oak',
        value: ClosetColor.OAK,
        colorCode: '#D8B589',
    },
];

export const doorColorOptions = [
    {
        name: 'White',
        value: DoorColor.WHITE,
        colorCode: '#ffffff',
    },
    {
        name: 'Grey',
        value: DoorColor.GREY,
        colorCode: '#808080',
    },
    {
        name: 'Oak',
        value: DoorColor.OAK,
        colorCode: '#D8B589',
    },
];

export const doorStyleOptions = [
    {
        name: 'Slab',
        value: DoorStyle.SLAB,
    },
    {
        name: 'Shaker',
        value: DoorStyle.SHAKER,
    },
];

export const handleColorOptions = [
    {
        name: 'Black',
        value: HandleColor.BLACK,
        colorCode:
            'linear-gradient(90deg, #000000 0%, #3D3D3D 50%, #797979 100%)',
    },
    {
        name: 'Chrome',
        value: HandleColor.CHROME,
        colorCode:
            'linear-gradient(90deg, #B5B5B5 0%, #D4D4D4 50%, #797979 100%)',
    },
    {
        name: 'Brass',
        value: HandleColor.BRASS,
        colorCode:
            'linear-gradient(90deg, #DAC672 0%, #FFEEB1 50%, #DAC672 100%)',
    },
    {
        name: 'Nickel',
        value: HandleColor.NICKEL,
        colorCode:
            'linear-gradient(90deg,#B1B1B1 0%, #B1B1B1 50%, #DFDFDF 100%)',
    },
];

export const handleStyleOptions = [
    {
        name: 'T Bar',
        value: HandleStyle.T_BAR,
    },
    {
        name: 'Knob',
        value: HandleStyle.KNOB,
    },
];

export const drawerColorOptions = [
    {
        name: 'White',
        value: DrawerColor.WHITE,
        colorCode: '#ffffff',
    },
    {
        name: 'Grey',
        value: DrawerColor.GREY,
        colorCode: '#808080',
    },
    {
        name: 'Oak',
        value: DrawerColor.OAK,
        colorCode: '#D8B589',
    },
];

export const drawerStyleOptions = [
    {
        name: 'Slab',
        value: DoorStyle.SLAB,
    },
    {
        name: 'Shaker',
        value: DoorStyle.SHAKER,
    },
];

export const rodColorOptions = [
    {
        name: 'Black',
        value: RodColor.BLACK,
        colorCode:
            'linear-gradient(90deg, #000000 0%, #3D3D3D 50%, #797979 100%)',
    },
    {
        name: 'Chrome',
        value: RodColor.CHROME,
        colorCode:
            'linear-gradient(90deg, #B5B5B5 0%, #D4D4D4 50%, #797979 100%)',
    },
    {
        name: 'Brass',
        value: RodColor.BRASS,
        colorCode:
            'linear-gradient(90deg, #DAC672 0%, #FFEEB1 50%, #DAC672 100%)',
    },
    {
        name: 'Nickel',
        value: RodColor.NICKEL,
        colorCode:
            'linear-gradient(90deg,#B1B1B1 0%, #B1B1B1 50%, #DFDFDF 100%)',
    },
];

export const MAPPING_COLLAPSE = Object.freeze({
    MAPPING: 'mapping',
    LIST: 'list',
});
